(function (root, factory) {
  const api = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  } else {
    root.Signaling = api;
  }
}(typeof window !== "undefined" ? window : this, () => {
  function requireString(value, name) {
    if (typeof value !== "string" || !value) {
      throw new TypeError(`${name} must be a non-empty string`);
    }
    return value;
  }

  function requireObject(value, name) {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
      throw new TypeError(`${name} must be an object`);
    }
    return value;
  }

  function validateStreamId(streamId) {
    if (!Number.isInteger(streamId) || streamId < 1 || streamId > 5) {
      throw new RangeError("stream ID must be an integer from 1 through 5");
    }
    return streamId;
  }

  function buildSurveillanceCommandRequest({
    requestId, deviceId, accessToken, command, params,
  }) {
    return {
      jsonrpc: "2.0",
      id: requireString(requestId, "request ID"),
      method: "update",
      params: {
        resource: `/orgs/o/sites/s/devices/${requireString(deviceId, "device ID")}/executeSurveillanceCommand`,
        accessToken: requireString(accessToken, "access token"),
        data: { command: requireString(command, "command"), params },
      },
    };
  }

  function buildStartViewingRequest({ requestId, deviceId, accessToken, streamId }) {
    return buildSurveillanceCommandRequest({
      requestId,
      deviceId,
      accessToken,
      command: "startViewing",
      params: { type: "Web", streamId: validateStreamId(streamId) },
    });
  }

  function buildAddCandidateRequest({
    requestId,
    deviceId,
    accessToken,
    sessionId,
    type = "App",
    client,
    stun,
  }) {
    return buildSurveillanceCommandRequest({
      requestId,
      deviceId,
      accessToken,
      command: "addCandidate",
      params: {
        sessionId: requireString(sessionId, "session ID"),
        type: requireString(type, "session type"),
        client: requireObject(client, "client"),
        stun: requireObject(stun, "stun"),
      },
    });
  }

  function buildStopViewingRequest({ requestId, deviceId, accessToken, sessionId }) {
    return buildSurveillanceCommandRequest({
      requestId,
      deviceId,
      accessToken,
      command: "stopViewing",
      params: { sessionId: requireString(sessionId, "session ID") },
    });
  }

  function buildCreatePlaybackStreamRequest({ requestId, deviceId, accessToken, startTime, endTime }) {
    return buildSurveillanceCommandRequest({
      requestId,
      deviceId,
      accessToken,
      command: "createPlaybackStream",
      params: {
        startTime: requireString(startTime, "start time"),
        endTime: requireString(endTime, "end time"),
      },
    });
  }

  return {
    buildAddCandidateRequest,
    buildStartViewingRequest,
    buildStopViewingRequest,
    buildCreatePlaybackStreamRequest,
    validateStreamId,
  };
}));
